import { createAction, createReducer } from '@reduxjs/toolkit'
import { apiCallBegan } from 'store/apiCalls'
import { gameIdSelector } from 'store/user/selectors'

// ACTIONS
const payRequested = createAction('accountsPayable/payRequested')
const paySuccessful = createAction('accountsPayable/paySuccessful')
const payFailed = createAction('accountsPayable/payFailed')

const accountsPayableClean = createAction('accountsPayable/clean')

// REDUCER
export const initialState = {
  payLoading: false,
  paySuccess: false
}

const accountsPayableReducer = createReducer(initialState, {
  [payRequested.type]: (state) => {
    state.payLoading = true
    state.paySuccess = false
  },
  [paySuccessful.type]: (state) => {
    state.payLoading = false
    state.paySuccess = true
  },
  [payFailed.type]: (state) => {
    state.payLoading = false
    state.paySuccess = false
  },
  [accountsPayableClean.type]: () => initialState
})

export default accountsPayableReducer

// Public actions
export const payAccountsPayable = () => (dispatch, getState) => {
  const currentState = getState()
  const id = gameIdSelector(currentState)

  if (!id) {
    dispatch(payFailed({ message: 'Game ID not found' }))
    return
  }

  dispatch(
    apiCallBegan({
      url: `/games/${id}/accounts_payable/pay`,
      method: 'POST',
      onStart: payRequested.type,
      onSuccess: paySuccessful.type,
      onError: payFailed.type
    })
  )
}

export const cleanAccountsPayable = () => (dispatch) => dispatch(accountsPayableClean())
